"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _SocialLink = _interopRequireDefault(require("./SocialLink"));
var _NavigationColumn = _interopRequireDefault(require("./NavigationColumn"));
var _Footer = require("./Footer.style");
var _MobileLanguageSelector = _interopRequireDefault(require("./MobileLanguageSelector"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Footer = function Footer(_ref) {
  var columnOneLinks = _ref.columnOneLinks,
    columnOneTitle = _ref.columnOneTitle,
    columnTwoLinks = _ref.columnTwoLinks,
    columnTwoTitle = _ref.columnTwoTitle,
    columnThreeLinks = _ref.columnThreeLinks,
    columnThreeTitle = _ref.columnThreeTitle,
    columnFourLinks = _ref.columnFourLinks,
    columnFourTitle = _ref.columnFourTitle,
    logo = _ref.logo,
    newsletterComponent = _ref.newsletterComponent,
    phone = _ref.phone,
    socialLinks = _ref.socialLinks,
    languageLinks = _ref.languageLinks,
    activeLanguage = _ref.activeLanguage,
    columnOneLogo = _ref.columnOneLogo;
  var navigationColumns = [{
    title: columnOneTitle,
    links: columnOneLinks
  }, {
    title: columnTwoTitle,
    links: columnTwoLinks
  }, {
    title: columnThreeTitle,
    links: columnThreeLinks
  }, {
    title: columnFourTitle,
    links: columnFourLinks
  }].filter(function (_ref2) {
    var title = _ref2.title,
      links = _ref2.links;
    return title && links;
  });
  var numberOfIcons = 5;
  return /*#__PURE__*/_react.default.createElement(_Footer.Wrapper, {
    "data-key": "max-footer"
  }, /*#__PURE__*/_react.default.createElement(_Footer.ColumnWrapper, {
    paddingBottom: true,
    fixed: true
  }, /*#__PURE__*/_react.default.createElement(_Footer.Logo, {
    "data-key": "max-footer__logo"
  }, logo), socialLinks && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Footer.SocialIconsContainer, {
    "data-key": "max-footer__social-icons"
  }, socialLinks.map(function (link, index) {
    return index < numberOfIcons && /*#__PURE__*/_react.default.createElement(_SocialLink.default, {
      key: "footer-social-".concat(link.title),
      link: link
    });
  })), socialLinks.length - 1 >= numberOfIcons && /*#__PURE__*/_react.default.createElement(_Footer.SocialIconsContainer, {
    "data-key": "max-footer__social-icons"
  }, socialLinks.map(function (link, index) {
    return index >= numberOfIcons && /*#__PURE__*/_react.default.createElement(_SocialLink.default, {
      key: "footer-social-".concat(link.title),
      link: link
    });
  }))), columnOneLogo, phone && /*#__PURE__*/_react.default.createElement(_Footer.CallButton, {
    "data-key": "max-footer__phone"
  }, phone)), newsletterComponent && /*#__PURE__*/_react.default.createElement(_Footer.ColumnWrapper, {
    paddingBottom: true,
    fixed: true
  }, newsletterComponent), navigationColumns && /*#__PURE__*/_react.default.createElement(_Footer.NavigationWrapper, null, navigationColumns.map(function (column, index) {
    var showBorder = index !== navigationColumns.length - 1;
    return column.title && column.links.length && /*#__PURE__*/_react.default.createElement(_NavigationColumn.default, {
      showBorder: showBorder,
      key: "max-footer-nav-".concat(index),
      title: column.title,
      links: column.links,
      dataKey: "max-footer-nav-".concat(index)
    });
  })), languageLinks && languageLinks.length > 1 && /*#__PURE__*/_react.default.createElement(_MobileLanguageSelector.default, {
    languageLinks: languageLinks,
    activeLanguage: activeLanguage
  }));
};
var _default = Footer;
exports.default = _default;